import { match } from 'ts-pattern';
import AddressFields from '~/components/AddressFields';
import Alert from '~/components/Alert';
import Card from '~/components/Card';
import Form from '~/components/Form';
import Submit from '~/components/Submit';
import { useIsLoading } from '~/utils/routing';
import {
  editActionTypeFormKey,
  useActionResult,
  useLoaderData,
} from './orderEditStage';

type LoaderData = Awaited<ReturnType<typeof useLoaderData>>;

function UpdateAddressForm({
  data,
}: {
  data: Extract<LoaderData, { editType: 'UPDATE_SHIPPING_ADDRESS' }>;
}) {
  const isLoading = useIsLoading();
  const { shippingAddress } = data;

  return (
    <Form name="addressForm">
      <input type="hidden" name={editActionTypeFormKey} value={data.editType} />
      <AddressFields address={shippingAddress} />
      <Submit loading={isLoading}>Continue</Submit>
    </Form>
  );
}

export default function OrderEditStagePage() {
  const loaderData = useLoaderData();
  const actionResult = useActionResult();

  const content = match(loaderData)
    .with({ editType: 'UPDATE_SHIPPING_ADDRESS' }, (data) => (
      <UpdateAddressForm data={data} />
    ))
    .exhaustive();

  return (
    <Card headline={loaderData.headline} hideHeader>
      {content}
      {actionResult?.ok === false && (
        <Alert variant="error" title={actionResult.message} />
      )}
    </Card>
  );
}
